(function () {
    var observer = new MutationObserver(function (mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check if the `.success` div was added
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1 && node.classList.contains('success')) {
                        console.log('Success div detected. Redirecting to the cart page...');
                        
                        // Redirect to the cart page
                        window.location.href = '/cart';
                    }
                });
            }
        }
    });

    // Start observing the entire document body
    observer.observe(document.body, { childList: true, subtree: true });

    console.log('MutationObserver is now watching for .success div.');
})();
